import {Injectable} from '@angular/core';
import {Moment} from 'moment-timezone';
import {AceLoggerService} from '@logging/ace-logger.service';
import {AceLogger} from '@logging/ace-logger';
import {MessageTranslateService} from '@shared/services';
@Injectable({
  providedIn: 'root'
})
export class CalendarUtilsService {
  private readonly logger: AceLogger;
  public TS_DISPLAY_FORMAT_WITH_TIMEZONE = 'ddd DD-MMM-YYYY HH:mm zz';
  public TS_DISPLAY_FORMAT_SECONDS_PRECISION_WITH_TIMEZONE = 'ddd DD-MMM-YYYY HH:mm:ss zz';
  public DAYS_OF_THE_WEEK = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

  constructor(private translateService: MessageTranslateService,
              logService: AceLoggerService) {
    this.logger = logService.create(CalendarUtilsService.name);

  }

  get monthList(): Array<{ id: number; name: string }> {
    return [{id: 0, name: this.translateService.instant('January')}, {id: 1, name: this.translateService.instant('February')},
      {id: 2, name: this.translateService.instant('March')}, {id: 3, name: this.translateService.instant('April')},
      {id: 4, name: this.translateService.instant('May')}, {id: 5, name: this.translateService.instant('June')},
      {id: 6, name: this.translateService.instant('July')}, {id: 7, name: this.translateService.instant('August')},
      {id: 8, name: this.translateService.instant('September')}, {id: 9, name: this.translateService.instant('October')},
      {id: 10, name: this.translateService.instant('November')}, {id: 11, name: this.translateService.instant('December')}];
  }

  get monthNames(): Map<number, string> {
    const m = new Map<number, string>();
    this.monthList.forEach(month => m.set(month.id, month.name));
    return m;
  }

  get dayList(): Array<{ id: number; name: string }> {
    return [{id: 0, name: this.translateService.instant('Monday')}, {id: 1, name: this.translateService.instant('Tuesday')},
      {id: 2, name: this.translateService.instant('Wednesday')}, {id: 3, name: this.translateService.instant('Thursday')},
      {id: 4, name: this.translateService.instant('Friday')}, {id: 5, name: this.translateService.instant('Saturday')},
      {id: 6, name: this.translateService.instant('Sunday')}];
  }

  get dayNames(): Map<number, string> {
    const m = new Map<number, string>();
    this.dayList.forEach(month => m.set(month.id, month.name));
    return m;
  }

  convertMomentToDisplayString(ts: Moment, timezone: string, displaySecondsPrecision = false): string | null {
    if (ts && timezone) {
      return ts.tz(timezone).format(displaySecondsPrecision ? this.TS_DISPLAY_FORMAT_SECONDS_PRECISION_WITH_TIMEZONE : this.TS_DISPLAY_FORMAT_WITH_TIMEZONE);
    } else {
      return null;
    }
  }
}
